/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForVmwareVcdMaster extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForVmwareVcdMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForVmwareVcdMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForVmwareVcdMaster>): ServiceAccountNativeDetailsForVmwareVcdMaster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForVmwareVcdMaster(), model);
        ServiceAccountNativeDetailsForVmwareVcdMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForVmwareVcdMaster>): ServiceAccountNativeDetailsForVmwareVcdMaster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForVmwareVcdMaster.newInstance(<ServiceAccountNativeDetailsForVmwareVcdMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdMaster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForVmwareVcdMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdMaster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForVmwareVcdMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
